module.exports = __webpack_public_path__ + "img/HARMO.6cc84d51.png";